import React from 'react';

const ExpandDropdownIcon = ({
  width = 14,
  height = 14,
  color = '#000',
  arrowPointsUp = false,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {arrowPointsUp ? (
      <path
        d="M4.73949 8.75004L7.00282 6.4867L9.26615 8.75004C9.37514 8.85927 9.5231 8.92065 9.6774 8.92065C9.8317 8.92065 9.97967 8.85927 10.0887 8.75004C10.3162 8.52254 10.3162 8.15504 10.0887 7.92754L7.41115 5.25004C7.18365 5.02254 6.81615 5.02254 6.58865 5.25004L3.91115 7.92754C3.68365 8.15504 3.68365 8.52254 3.91115 8.75004C4.13865 8.9717 4.51199 8.97754 4.73949 8.75004V8.75004Z"
        fill={color}
      />
    ) : (
      <path
        d="M9.26039 5.24996L6.99706 7.5133L4.73373 5.24996C4.62474 5.14073 4.47678 5.07935 4.32248 5.07935C4.16817 5.07935 4.02021 5.14073 3.91123 5.24996C3.68373 5.47746 3.68373 5.84496 3.91123 6.07246L6.58873 8.74996C6.81623 8.97746 7.18373 8.97746 7.41123 8.74996L10.0887 6.07246C10.3162 5.84496 10.3162 5.47746 10.0887 5.24996C9.86123 5.0283 9.48789 5.02246 9.26039 5.24996Z"
        fill={color}
      />
    )}
  </svg>
);

export default ExpandDropdownIcon;
